export const socialLinks = [
  {
    title: 'GitHub',
    description: '저의 소스코드와 프로젝트 변천사를 확인하실 수 있습니다.',
    image: 'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
    link: 'https://github.com/01MINAH'
  },
  {
    title: 'Tistory',
    description: '학습한 내용과 기술적인 고민들을 기록하는 블로그입니다.',
    image: 'https://mblogthumb-phinf.pstatic.net/MjAyMTA1MDNfMTIx/MDAxNjIwMDE2ODUzODY2.GpIC8w2H_pIqAahd_Km5NEsk-3gAr88XK9BNr1Egc9Yg.PJsJNcO2jbk2fpTnEb4kZRA857QRyU4CwYNZk8lYsbwg.PNG.xavisnet/%ED%8B%B0%EC%8A%A4%ED%86%A0%EB%A6%AC.png?type=w800',
    link: 'https://minah0904.tistory.com/'
  },
  {
    title: 'Velog',
    description: '개발 트렌드와 일상적인 이야기를 공유합니다.',
    image: 'https://velog.velcdn.com/images/sinvercoin/post/df9b0827-616c-4f87-91d7-0211d5b5e694/image.png',
    link: 'https://velog.io/@minah_94/posts'
  },
  {
    title: 'Notion',
    description: '개인적인 포트폴리오 정리가 포함되어 있습니다.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png',
    link: 'https://almond-seal-43a.notion.site/SW-18e5ecacb6f28021a365f1f71299c282'
  }
];
